/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const EmailSend: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M15.9185 1.0592C15.8473 0.996894 15.746 0.982439 15.6601 1.02218L0.138394 8.21502C0.0548304 8.25375 0.00101877 8.33691 1.42847e-05 8.42879C-0.000990199 8.52067 0.0510516 8.60497 0.133802 8.64547L4.52641 10.7955C4.60696 10.835 4.703 10.8261 4.77494 10.7724L9.04577 7.58877L5.69299 11.0284C5.64516 11.0775 5.62077 11.1447 5.62603 11.213L5.95985 15.549C5.96727 15.6451 6.03184 15.7272 6.12363 15.7573C6.14817 15.7653 6.17338 15.7692 6.1983 15.7692C6.26665 15.7692 6.33314 15.74 6.37939 15.6866L8.71084 12.992L11.593 14.3655C11.6556 14.3953 11.728 14.3965 11.7915 14.3689C11.8551 14.3413 11.9035 14.2876 11.9243 14.2217L15.989 1.30999C16.0174 1.21983 15.9897 1.1215 15.9185 1.0592Z' />
		</Svg>
	);
};

export { EmailSend };
